module.exports = __webpack_public_path__ + "img/logo.a36c145b.png";